// extracted by mini-css-extract-plugin
export default {"App":"App_App__sJeqI","appDiv":"App_appDiv__RpgG1"};